import * as React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import { DialogPropsBase } from '../../common/props/commonFormProps';
import { RegisteredPersonModel } from '../../admin/models/CompanyModels';
import { localizations } from '../../localization/localization';

type SubmitType = () => void;
type CancelType = () => void;

interface DeleteUserConfirmProps {
    user: RegisteredPersonModel
}

type Props = DialogPropsBase<SubmitType, CancelType> & DeleteUserConfirmProps;

const DeleteUserConfirmation: React.SFC<Props> = (props) => {
    return <Dialog open={props.isOpen}>
        <DialogTitle>{localizations.settings.deleteUserConfirmationTitle}</DialogTitle>
        <DialogContent>
            <Typography paragraph>{localizations.settings.deleteUserQuestion} <strong>{`${props.user.firstName} ${props.user.lastName}`}</strong>?</Typography>
            <Typography>{localizations.settings.deleteUserDescription}</Typography>
        </DialogContent>
        <DialogActions>
            <Button onClick={() => props.onCancel()}>{localizations.actions.cancel}</Button>
            <Button onClick={() => props.onSubmit()}>{localizations.actions.accept}</Button>
        </DialogActions>
    </Dialog>
}

export default DeleteUserConfirmation;


// WEBPACK FOOTER //
// ./src/account/forms/DeleteUserConfirmation.tsx